import styles from "./styles.module.scss";
import { motion } from "framer-motion";
import { header_submenu_animation } from "../../animation";
import { IoIosArrowForward } from "react-icons/io";
import { ClassCurrentMenu } from "../../core-nextv3/menu/menu.api";
import CustomLink from "@/component-nextv3/CustomLink";

export const MenuType = ({ menu }: any) => 
{
    const getMenu = (item:any, index:number) =>  
    {
        switch (item?.type?.value) 
        {
            case "path":
                return (
                    <>
                        <CustomLink
                            className={(item.highlight ? styles.highlight : "") + " " + (item.bold ? styles.bold : "") + " " + styles.titleName + " " + styles[ClassCurrentMenu(item)]}
                            href={`${item.link}`}
                            key={`path-${index}`}
                        >
                            <span>
                                {item?.name}
                            </span>
                        </CustomLink>
                        {item?._children?.length > 0 && (
                            <motion.ul
                                className={styles.subMenuGrid}
                                variants={header_submenu_animation}
                            >
                                <div className={styles.subMenuChild}>
                                    <div className={styles.child}>
                                        <p className={styles.titleSubMenu}>Categoria</p>
                                        <div className={styles.childNavigation}>
                                            {item?._children?.map((child: any, index:number) => (
                                                child.status && <div key={index}>{getMenu(child, index)}</div>
                                            )
                                            )}
                                            <CustomLink href={`${item.link}`} className={styles.fixed}>Ver Todos <IoIosArrowForward /></CustomLink>
                                        </div>
                                    </div>
                                </div>
                            </motion.ul>
                        )}
                    </>
                );
            case "category":
                return (
                    <>
                        <CustomLink
                            href={`/categoria/${item?.category?.slug}/`}
                            className={(item.highlight ? styles.highlight : "") + " " + (item.bold ? styles.bold : "") + " " + styles.titleName + " " + styles[ClassCurrentMenu(item)]}                  
                            key={`category-${index}`}
                        >
                            <span>
                                {item?.name}
                            </span>
                        </CustomLink>

                        {item?.category?._children?.length > 0 && (
                            <motion.ul
                                className={styles.subMenuGrid}
                                variants={header_submenu_animation}
                            >
                                <CustomLink href={`/categoria/${item?.category?.slug}/`}>Ver Todos</CustomLink>
                                <div className={styles.teste}>
                                    {item?.category?._children?.map(
                                        (child: any, index:number) => (
                                            child.status && <div key={index}>{getMenu(child, index)}</div>
                                        )
                                    )}
                                </div>
                            </motion.ul>
                        )}
                    </>
                );

            case "collection":
                return (
                    <CustomLink
                        href={`/colecao/${item?.collection?.slug}/1/`}
                        className={(item.highlight ? styles.highlight : "") + " " + (item.bold ? styles.bold : "") + " " + styles.titleName + " " + styles[ClassCurrentMenu(item)]}
                        key={`collection-${index}`}
                    >
                        <span>
                            {item?.name}
                        </span>
                    </CustomLink>
                );
            default:
                return null;
        }
    };

    return (
        <div className={styles.menuType}>
            {menu?.map((item: any, index:number) =>
                item.status && ( <div className={styles.navigation} key={index}>
                    <motion.ul
                        className={styles.menuItemGrid}
                        initial="animate"
                        animate="animate"
                        whileHover="hover"
                    >
                        {getMenu(item, index)}
                    </motion.ul>
                </div>
                )
            )}
        </div>
    );
};
